"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var generate_playready_license_request_1 = require("./generate-playready-license-request");
var playready_extract_encoded_response_data_1 = require("./playready-extract-encoded-response-data");
var client_lib_js_common_request_1 = require("@sky-uk-ott/client-lib-js-common-request");
exports.createPlayreadyKeySystemOptionsGenerator = function () {
    return new __1.KeySystemOptionsGenerator(client_lib_js_player_addons_common_player_1.DrmType.PlayReady, 'com.microsoft.playready', new __1.HTTPLicenseAcquisitionStrategy(__1.arcusPlayreadyRequestDecorator(generate_playready_license_request_1.default), playready_extract_encoded_response_data_1.default, client_lib_js_common_request_1.request));
};
